import { PolicyCategory } from '../../types/policies';
import {
  ShieldBan,
  Wrench,
} from 'lucide-react';
import { Badge } from '../../../../ui/common-ui/badge';
import { CloudPolicyType } from '../../types/policies';

interface CategoryFilterProps {
  selectedCategory: PolicyCategory | null;
  onCategoryChange: (category: PolicyCategory | null) => void;
  counts: { guardrail: number; remediation: number };
}

const categories: { value: CloudPolicyType; label: string; icon: any; color: string }[] = [
  { value: 'GUARDRAIL', label: 'Guardrail', icon: ShieldBan, color: 'text-indigo-500' },
  { value: 'REMEDIATION', label: 'Remediation', icon: Wrench, color: 'text-amber-500' },
];

export const CategoryFilter = ({ selectedCategory, onCategoryChange, counts }: CategoryFilterProps) => {
  return (
    <div className="flex items-center gap-1 p-1 bg-muted/30 rounded-xl">
      {categories.map(({ value, label, icon: Icon, color }) => (
        <button
          key={value}
          onClick={() => onCategoryChange(selectedCategory === value ? null : value)}
          className={`relative flex items-center justify-center gap-2 px-3 py-1.5 rounded-lg text-[13px] font-medium transition-all duration-300 ${
            selectedCategory === value
              ? 'bg-gradient-to-br from-card to-card/80 text-foreground shadow-sm ring-1 ring-border/50 scale-105'
              : 'text-muted-foreground hover:text-foreground hover:bg-card/50 hover:scale-105'
          }`}
        >
          <Icon className={`h-4 w-4 transition-all duration-300 ${color} ${selectedCategory === value ? '' : 'opacity-40'}`} />
          {label}
        </button>
      ))}
    </div>
  );
};
